/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `hsa_configuration_data` message.
 *
 * Configuration data for HSA custom data logging
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class HsaConfigurationDataMesg : Mesg {
    public constructor() : super("HsaConfigurationData", Profile.MesgNum.HSA_CONFIGURATION_DATA)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp, in s. Encoded configuration data */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** Number of values stored in data. */
    public val numData: Int
        get() = getField(DATA_FIELD_NUM)?.numValues ?: 0

    /** data. Encoded configuration data. Health SDK use only */
    public var data: List<UByte?>?
        get() {
            val field = getField(DATA_FIELD_NUM) ?: return null
            return List(field.numValues) { getData(it) }
        }
        set(value) {
            removeField(DATA_FIELD_NUM)
            value?.forEachIndexed { index, element -> setData(index, element) }
        }

    public fun getData(index: Int): UByte? =
        getFieldValue(DATA_FIELD_NUM, index) as? UByte

    public fun setData(index: Int, value: UByte?) {
        setFieldValue(DATA_FIELD_NUM, value, index)
    }

    /** data_size. Size in bytes of data field */
    public var dataSize: UByte?
        get() = getFieldValue(DATA_SIZE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(DATA_SIZE_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val DATA_FIELD_NUM: UByte = 0u
        public const val DATA_SIZE_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[0] = Field("Data", 0u, BaseType.BYTE, 1.0, 0.0, "", false)
            fields[1] = Field("DataSize", 1u, BaseType.UINT8, 1.0, 0.0, "", false)
            return fields
        }
    }
}
